// store/modules/blogStore.js
import axios from "axios";
import { appConstants } from "../../../common/constants";
export default {
  namespaced: true,
  state: {
    blogs: [],
    totalRecords: 0,
  },
  mutations: {
    setBlogs(state, blog) {
      if (blog.pagingMode === appConstants.enums.pagingMode.loadMore) {
        state.blogs = [...state.blogs, ...blog.list];
      } else {
        state.blogs = blog.list;
      }
      state.totalRecords = blog.totalRecords;
    },
  },
  getters: {
    getBlogs: (state) => state.blogs,
    canLoadMore(state) {
      return state.blogs.length < state.totalRecords;
    },
  },
  actions: {
    async fetchBlogs({ state, commit }, param) {
      if (state.blogs.length === 0 || (param && param.pagingMode === appConstants.enums.pagingMode.loadMore)) {
        try {
          const response = await axios.get(`${process.env.VUE_APP_BLOG_URL}wp-json/wp/v2/posts?page=${param.data.page}&per_page=${param.data.pageSize}`);
          const blogs = response.data.map((post) => ({
            id: post.id,
            title: post.title,
            excerpt: post.excerpt,
            date: post.published_date || "N/A",
            content: post.content,
            featured_image_src: post.featured_image_src || "/assets/images/default-placeholder.png",
          }));
          commit("setBlogs", {
            list: blogs,
            pagingMode: param.pagingMode,
            totalRecords: parseInt(response.headers["x-wp-total"]),
          });
        } catch (error) {
          console.error("Error fetching blogs:", error);
        }
      } else {
        return state.blogs;
      }
    },
  },
};
